<template>
    <div>
        <template v-if="extrasToEdit && extrasToEdit.length > 0">
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="extraNameWidth">Extra</th>
                    <th class="pb-2">Seller</th>
                    <th class="pb-2 text-center">Commission</th>
                    <th class="pb-2 text-center" style="width: 100px;">Availability</th>
                    <th class="pb-2 text-center" style="width: 120px;">Price/unit</th>
                    <th class="addRemoveWidth" style="width: 150px;"></th>
                </tr>
                <tr class="border-bottom-light border-top-light" v-for="extra in extrasToEdit">
                    <td class="darker pl-2">{{ extra.component.name }} - {{extra.componentPrice.name}}</td>
                    <td class="fs-small">{{showSeller(extra)}}</td>
                    <td class="fs-small text-center">{{showCommission(extra)}}</td>
                    <td class="fs-small text-center">{{showAvailability(extra)}}</td>
                    <td class="fs-small text-center">{{ formatPrice(extra.componentPrice.grossprice) }} €</td>
                    <td class="d-flex flex-row justify-content-center py-1">
                        <span class="border-light py-1 px-2 radius-normal mx-1 text-center pointer" @click="changeExtraQtd2('remove', extra)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <!-- <span class="border-light py-1 px-2 radius-normal mx-1 text-center darker font-weight-600" style="width: 2.2rem">{{extra.quantity}}</span> -->
                        <input type="number" placeholder="0" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" v-model="extra.quantity" @keyup="quantityChanged(extra)" @focus="extraFocused(extra)">
                        <span class="border-light py-1 px-2 radius-normal mx-1 text-center pointer" @click="changeExtraQtd2('add', extra)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>
                <tr class="fs-large">
                    <th class="pt-2 pl-2 extraNameWidth">Total</th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2"></th>
                    <!-- <th class="pt-2 pb-2 text-center">{{formatPrice(getReservationCalculations.totalComponentGrossprice)}} €</th> -->
                    <th class="pt-2 pb-2 text-center">{{formatPrice(calculatedExtrasTotal)}} €</th>
                    <th class="pt-2 addRemoveWidth text-center">{{totalExtras}}</th>
                </tr>
            </table>

        </template>

        <div v-else class="fs-large dark text-center p-2">
            There are no extras to show
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import { mapGetters, mapActions } from 'vuex'
export default {
    data: function() {
        return {
            extrasArray: null,
            extraItemLoaction: null,
            extrasToEdit: null,
        }
    },
    props: {
        reservation: {
            type: Object
        },
        extrasArrayImported: {
            type: Array
        },
    },
    created: function() {
        this.extrasArray = this.extrasArrayImported
        this.setExtrasToEdit()
    },
    mixins:[
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'getReservationCalculations',
            'getSalesChannels'
        ]),

        totalExtras: function(){
            let total = 0;

            for(let extra of this.extrasArray){
                if(extra.quantity){
                    total += Number(extra.quantity)
                }
            }
            // this.$set(this.reservation, 'totalExtas', total)
            return total
        },
        hasSelectedExtras: function() {
            if(!this.extrasArray.length == 0){
                return false
            } else {
                let output = false;
                for(let extra of this.extrasArray){
                    if(extra.quantity > 0){
                        output = true
                    }
                }
                return output
            }
        },
        calculatedExtrasTotal: function () {
            let total = 0

            this.extrasArrayImported.map(extra => {
                total += Number(extra.componentPrice.value) * extra.quantity
            })

            return total
        }
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        setExtrasToEdit: function () {
            this.extrasToEdit = this.extrasArray.filter(extra => {
                return extra.quantity > 0
                // return true
            })
        },
        showSeller: function(extra) {
            if(extra.creatorAgent){
                return extra.creatorAgent.brandName
            } else if(extra.creatorUserAccount){
                return extra.creatorUserAccount.name
            } else {
                return this.getSalesChannels.find(channel => channel.channelType == extra.channelType).brandName
            }
        },
        showAvailability: function(extra) {
            if(extra.originalQuantity == 0){
                return 'unlimited'
            } else {
                return isNaN(extra.quantityAvailable)? '' : extra.quantityAvailable
            }
        },
        extraQtd: function(extra){
            let total = 0

            if(this.extrasArray){
                var currentBookingComponent = this.extrasArray.find(bookingComponent => {
                    if(bookingComponent.componentPrice){
                        return bookingComponent.component.id == extra.component.id && bookingComponent.componentPrice.id == extra.componentPrice.id
                    } else {
                        return bookingComponent.component.id == extra.component.id
                    }
                })

                if(currentBookingComponent){
                    total = currentBookingComponent.quantity
                }
            } else {
                total = extra.quantityBooked
            }

            return total
        },
        extraQtd2: function(extra){
            return extra.quantity
        },
        showCommission: function(extra) {
            if(extra.commissionComponentValue && extra.commissionComponentValueType){
                return extra.commissionComponentValue+(extra.commissionComponentValueType == 1?'%':'€')
            } else {
                return null
            }
        },
        changeExtraQtd2: function(addRemove, extra) {
            if(this.isReservationReadOnly){
                this.readOnlyShowMessage()
                return false
            }

            if(this.reservation.updateFlags){
                this.$set(this.reservation.updateFlags, 'extras', true)
            }



            if(addRemove == 'add'){
                // this triggers when the reservation has a extra that is no longer available on the product
                if(extra.componentExtinct && extra.componentExtinct){
                    this.$toasted.info('This extra is no longer available on this product.')
                    return false
                }

                // is unlimied
                if(extra.originalQuantity == 0){
                extra.quantity++
                } else {
                    if(extra.quantityAvailable > 0){
                        extra.quantity++
                        // extra.quantityAvailable--
                        this.changeExtraQuantityAvailable(extra, 'remove')
                    }
                }

            } else if(addRemove == 'remove'){
                if(extra.quantity > 0){
                    extra.quantity--
                    // not unlimied
                    if(extra.originalQuantity != 0){
                        // extra.quantityAvailable++
                        this.changeExtraQuantityAvailable(extra, 'add')
                    }
                }
            }
            this.syncAvailabiliity(extra)
            //asks api for calculations
            // this.setReservationCalculations(this.reservation);


        },
        changeExtraQuantityAvailable: function (extra, action) {
            this.extrasToEdit.map(extraMain => {
                if(extraMain.component.id == extra.component.id){
                    if(action == 'add'){
                        extraMain.quantityAvailable++
                        return true
                    } else if (action == 'remove') {
                        extraMain.quantityAvailable--
                        return true
                    }
                }
            })
        },
        // changeExtraQtdCreateReservation: function(addRemove, extra) {
        //     if(addRemove == 'add'){
        //
        //         if(!extra.quantityBooked){
        //             // extra.quantityBooked = 0;
        //             this.$set(extra, 'quantityBooked', 0)
        //         }
        //         if(extra.quantity == 0 || extra.quantityBooked < extra.quantityAvailable){
        //         // if(extra.quantity == 0 || extra.quantityBooked < this.extraQtd(extra)){
        //             extra.quantityBooked++;
        //         }
        //
        //     } else if(addRemove == 'remove'){
        //
        //         if(extra.quantityBooked > 0){
        //             extra.quantityBooked--;
        //         }
        //
        //     }
        //
        //     //if editing reservation set the total on the right part of the reservation object
        //     if(this.reservation.bookingComponents){
        //         this.reservation.bookingComponents.map(bookingComponent => {
        //             if(bookingComponent.component.id == extra.component.id){
        //                 bookingComponent.quantity = extra.quantityBooked
        //             }
        //         })
        //     }
        //
        //
        //     //asks api for calculations
        //     this.setReservationCalculations(this.reservation);
        // },
        quantityChanged: function(extra){
            if(this.reservation.updateFlags){
                this.$set(this.reservation.updateFlags, 'extras', true)
            }

            if(extra.quantity <= 0){
                extra.quantity = null
            }

            if(extra.originalQuantity != 0 && extra.quantity > extra.originalQuantity){
                extra.quantity = extra.originalQuantity
                this.$toasted.error('Selected quantity can not be higher than available quantity');
            }


            extra.quantityAvailable = extra.originalQuantity - extra.quantity

            this.setReservationCalculations(this.reservation);
        },
        extraFocused: function (extra) {
            // fix to simulate "placeholder" with 0 value
            if(extra.quantity == 0){
                extra.quantity = null
            }
        },
        fixQuantityBooked: function() {
            //when editing reservation the information on reservation.event.eventComponents[x] refers to the total sold of the event
            //so this fix set the reservation.event.eventComponents[x].quantityBooked to the same as in reservation.bookingComponents[x].quantity

            let vm = this

            // vm.reservation.bookingComponents.map(componentA => {
            for(var componentA of vm.reservation.bookingComponents){
                vm.reservation.event.eventComponents.map(componentToFix => {
                    if(componentA.component.id == componentToFix.component.id){
                        componentToFix.quantityBooked = componentA.quantity
                        vm.$set(componentToFix, 'fixed', true)
                    }
                })
            }

            // if there is any wrong quantity remaining (not fixed) will be set to zero
            vm.reservation.event.eventComponents.map(componentToFix => {
                if(!componentToFix.fixed){
                    componentToFix.quantityBooked = 0
                }
            })

        },
        syncAvailabiliity: function (currentComponent) {

            this.reservation.bookingComponents.map(bookingComponent => {
                if(bookingComponent.id != currentComponent.id && bookingComponent.component.id == currentComponent.component.id){
                    bookingComponent.quantityAvailable = currentComponent.quantityAvailable
                }
            })
            this.reservation.event.eventComponents.map(eventComponent => {
                if(eventComponent.component.id == currentComponent.component.id){
                    eventComponent.quantityAvailable = currentComponent.quantityAvailable
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ExtrasManager.vue?2bd5d98f